import { useState } from "react";
import { Linkedin, Twitter, Link2, Check, Share2 } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ url, title = "StUpEco Hub", className = "", testId = "share" }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const enc = encodeURIComponent(shareUrl);
  const encTitle = encodeURIComponent(title);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Could not copy link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url: shareUrl }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const btn = "inline-flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--hairline)] bg-[color:var(--surface)] text-[color:var(--ink-soft)] transition-colors hover:border-[color:var(--ink)] hover:text-[color:var(--ink)]";

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid={testId}>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc}`} target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn" data-testid={`${testId}-linkedin`} className={btn}><Linkedin className="h-4 w-4" /></a>
      <a href={`https://twitter.com/intent/tweet?url=${enc}&text=${encTitle}`} target="_blank" rel="noopener noreferrer" aria-label="Share on X" data-testid={`${testId}-twitter`} className={btn}><Twitter className="h-4 w-4" /></a>
      <button type="button" onClick={copy} aria-label="Copy link" data-testid={`${testId}-copy`} className={btn}>{copied ? <Check className="h-4 w-4 text-[color:var(--brand-green)]" /> : <Link2 className="h-4 w-4" />}</button>
      <button type="button" onClick={nativeShare} aria-label="Share" data-testid={`${testId}-native`} className={btn}><Share2 className="h-4 w-4" /></button>
    </div>
  );
}
